import "./external-screens.scss";
import { Switch, Route } from "react-router-dom";

import Header from "../../components/header";
import Footer from "../../components/footer";

import Home from "../../pages/home";
import About from "../../pages/about";
import Media from "../../pages/media";
import News from "../../pages/news";
import Contact from "../../pages/contact";
import Login from "../../pages/login";
import PasswordReset from "../../pages/password-reset";
import Register from "../../pages/register";



const ExternalScreens = () => {
  return (
    <div className="external-screens-container">
      <Header />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/home" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/media" component={Media} />
        <Route exact path="/news" component={News} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/login" component={Login}/>
        <Route exact path="/login/password" component={PasswordReset}/>
        <Route exact path="/register" component={Register}/>

        <Route path="/" component={Home} />
      </Switch>
      <Footer />
    </div>
  );
};

export default ExternalScreens;
